import type {
  Column,
  ProcessUnpinnedColumnsParams,
} from '@ag-grid-community/core';

/**
 * DataGridPinnedUtil - I decide which pinned columns ag-grid may unpin when the viewport is too
 * narrow to hold them. ONLY concerned with that question - no pinning, no sizing.
 */
export const DataGridPinnedUtil = {
  /**
   * **`lockPinned` means the column stays put, including here.**
   *
   * ag-grid's `ViewportSizeFeature` unpins whatever does not fit a narrow viewport and **never
   * re-pins it** when the room comes back, so a grid inside a panel that animates open loses its
   * pinned column for good: the check bails below 50px, fires once the panel crosses it while the
   * body is still only tens of pixels wide, and nothing restores the column afterwards.
   *
   * Every other `lockPinned` check in ag-grid is in the drag paths, so without this a column
   * declared locked still slides into the centre on its own.
   */
  unpinnable({ columns }: ProcessUnpinnedColumnsParams): Column[] {
    return columns.filter(column => !column.getColDef().lockPinned);
  },
};
